import React, { useState, useEffect } from 'react';
import { Card, Select, Toast, Spin, Typography, DatePicker } from '@douyinfe/semi-ui';

const XcxDataScreen = () => {
  return (
    <Typography.Title heading={3}>数据大屏 TODO</Typography.Title>
  );
};

export default XcxDataScreen;